module.exports = __webpack_public_path__ + "static/js/NoiseWorker.af6f2b86.chunk.worker.js"